import { render, staticRenderFns } from "./VideoEdit.vue?vue&type=template&id=22721178&scoped=true&"
import script from "./VideoEdit.vue?vue&type=script&lang=js&"
export * from "./VideoEdit.vue?vue&type=script&lang=js&"
import style0 from "./VideoEdit.vue?vue&type=style&index=0&id=22721178&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22721178",
  null
  
)

export default component.exports